import React from 'react';
import { useParams } from 'react-router-dom';
import ProposalApplicationForm from './ProposalApplicationForm'; // Your existing component

const ProposalPrint: React.FC = () => {
  const { quoteId } = useParams<{ quoteId: string }>();

  // Use the same component but with print-specific props or styling
  return (
    <div className="print-container">
      <style>
        {`
          @media print {
            @page {
              margin: 20mm 15mm;
            }
            
            body {
              font-size: 12pt;
              line-height: 1.4;
            }
            
            .no-print {
              display: none !important;
            }
            
            button, nav, footer {
              display: none !important;
            }
            
            .page-break {
              page-break-before: always;
            }
            
            .avoid-break {
              page-break-inside: avoid;
            }
            
            table {
              page-break-inside: avoid;
            }
          }
          
          .print-watermark {
            display: none;
          }
          
          @media screen {
            .print-only {
              display: none;
            }
          }
        `}
      </style>
      
      {/* Optional watermark for printed copies */}
      <div className="print-watermark" style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%) rotate(-45deg)',
        fontSize: '60px',
        opacity: 0.1,
        color: '#000',
        zIndex: 1000,
        pointerEvents: 'none',
      }}>
        CONFIDENTIAL
      </div>
      
      <ProposalApplicationForm />
    </div>
  );
};

export default ProposalPrint;